<template>
  <!-- 线索详情 -->
  <div class="container">
    <!-- 顶部卡片 -->
    <div class="head">
      <!-- 左侧企业信息 -->
      <div class="left">
        <div class="img">
          <img :src="row.logo" alt="" />
        </div>
        <div class="text">
          <el-popover
            placement="top-start"
            width="250"
            trigger="hover"
            :content="row.enterpriseName"
          >
            <div slot="reference" class="title">{{ row.enterpriseName }}</div>
          </el-popover>
          <div class="position">
            <div class="site">
              <span>{{ row.nation }}</span>
              <span>{{ '-' + row.province }}</span>
              <span v-if="row.city">
                {{ '-' + row.city }}
              </span>
            </div>
            <div class="priority">
              <div v-if="row.priority == 0">
                <span>低</span>
              </div>
              <div v-if="row.priority == 1">
                <span>中</span>
              </div>
              <div v-if="row.priority == 2">
                <span>高</span>
              </div>
              <div v-if="row.priority == 3" style="min-width: 30px; text-align: center">
                <span>更高</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间步骤条 -->
      <div class="center">
        <el-steps :active="active" align-center>
          <!-- 企业导入 -->
          <el-step
            :description="clueScheduleTimeObj.clueTime == null ? '' : clueScheduleTimeObj.clueTime"
          >
            <template slot="title">
              <div class="item">
                <div class="img">
                  <img src="../../../assets/icons/enterprise-import.png" alt="" />
                </div>
                <div>企业导入</div>
              </div>
            </template>
          </el-step>
          <!-- 关键人导入 -->
          <el-step
            :description="
              clueScheduleTimeObj.keyPersonTime == null ? '' : clueScheduleTimeObj.keyPersonTime
            "
          >
            <template slot="title">
              <div class="item">
                <div class="img">
                  <img src="../../../assets/icons/key-person-import.png" alt="" />
                </div>
                <div>关键人导入</div>
              </div>
            </template>
          </el-step>
          <!-- 链接方导入 -->
          <el-step
            :description="
              clueScheduleTimeObj.linksPartyTime == null ? '' : clueScheduleTimeObj.linksPartyTime
            "
          >
            <template slot="title">
              <div class="item">
                <div class="img">
                  <img src="../../../assets/icons/linker-import.png" alt="" />
                </div>
                <div>链接方导入</div>
              </div>
            </template>
          </el-step>
          <!-- 企业对接 -->
          <el-step
            :description="
              clueScheduleTimeObj.peopleTime == null ? '' : clueScheduleTimeObj.peopleTime
            "
          >
            <template slot="title">
              <div class="item">
                <div class="img">
                  <img src="../../../assets/icons/enterprise-abutment.png" alt="" />
                </div>
                <div>企业对接</div>
              </div>
            </template>
          </el-step>
          <!-- 企业签约 -->
          <el-step
            :description="
              clueScheduleTimeObj.contractTime == null ? '' : clueScheduleTimeObj.contractTime
            "
          >
            <template slot="title">
              <div class="item">
                <div class="img">
                  <img src="../../../assets/icons/enterprise-sign-up.png" alt="" />
                </div>
                <div>企业签约</div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <!-- 右侧信息 -->
      <div class="right">
        <!-- 信息员 商务经理信息 -->
        <div class="information">
          <div class="messenger">
            <div class="messenger_icon">
              <img src="../../../assets/icons/clue-person.png" alt="" />
            </div>
            <div class="text">
              <span>线索信息员：</span>
            </div>
            <div class="userName">
              <span>{{ row.clueMessenger }}</span>
            </div>
          </div>
          <div class="business_manager">
            <div class="business_manager_icon">
              <img src="../../../assets/icons/business-manager.png" alt="" />
            </div>
            <div class="text">
              <span>商务经理：</span>
            </div>
            <div class="userName">
              <span>{{ row.englishName }}</span>
            </div>
          </div>
        </div>
        <!-- 编辑信息 -->
        <div class="redactInform" @click="showEditInfoDialog(row)">
          <i class="el-icon-edit-outline redactInform_icon"></i>
          <div class="text">编辑信息</div>
        </div>
      </div>
    </div>
    <!-- tab页签 -->
    <div class="tabs">
      <div
        class="tab"
        :class="item.id == tabActive ? 'tabActiveClass' : ''"
        v-for="item in tabList"
        :key="item.id"
        @click="clickTab(item)"
      >
        <div :style="{ display: 'flex' }">
          <div class="text">{{ item.value }}</div>
          <div class="quantity" v-if="item.id == tabActive && item.id != 3">{{ quantity }}</div>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content">
      <!-- 关键人 -->
      <div v-if="tabActive == 0">
        <keyPerson @quantity="quantityTotal"></keyPerson>
      </div>
      <!-- 链接方 -->
      <div v-if="tabActive == 1">
        <linkTarget @quantity="quantityTotal"></linkTarget>
      </div>
      <!-- 企业对接 -->
      <div v-if="tabActive == 2">
        <enterpriseDocking @quantity="quantityTotal"></enterpriseDocking>
      </div>
      <!-- 签约 -->
      <div v-if="tabActive == 3">
        <signContract @quantity="quantityTotal"></signContract>
      </div>
      <!-- 关联资讯 -->
      <div v-if="tabActive == 4">
        <correlationInform @quantity="quantityTotal"></correlationInform>
      </div>
    </div>
    <!-- 编辑对话框区域 -->
    <div class="dialog">
      <el-dialog @close="editInfoDialogClose" :visible.sync="editInfoDialogVisible" width="50%">
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt">编辑线索</div>
        </div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="form" label-width="119px">
            <el-form-item label="企业logo：" prop="logo">
              <uploadLogo
                :imageShow.sync="form.logo"
                @uploadOneImgShow="uploadOneImgShow"
              ></uploadLogo>
            </el-form-item>
            <el-form-item label="企业简称：" prop="enterpriseAbbreviation">
              <el-input
                v-model="form.enterpriseAbbreviation"
                placeholder="请输入企业简称"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业全称：" prop="enterpriseName">
              <el-input v-model="form.enterpriseName" placeholder="请输入企业全称"></el-input>
            </el-form-item>
            <el-form-item label="地点：" prop="enterpriseName">
              <div class="position">
                <CascaderArea
                  :country="form.nation"
                  :province="form.province"
                  :city="form.city"
                  @searchArae="dialogSearchArae"
                ></CascaderArea>
              </div>
            </el-form-item>
            <el-form-item label="来源方式：" prop="sourceWay">
              <div class="sourceWay">
                <div
                  v-for="item in sourceWayList"
                  :key="item.id"
                  class="item"
                  :class="item.id == form.sourceWay ? 'activeSourceWay' : ''"
                  @click="clickSourceWay(item)"
                >
                  <span>{{ item.value }}</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="线索信息员：" prop="clueMessenger">
              <el-input v-model="form.clueMessenger" placeholder="请输入线索信息员"></el-input>
            </el-form-item>
            <el-form-item label="商务经理：" prop="englishName" class="commercial_manager">
              <el-select v-model="form.englishName" placeholder="请选择">
                <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item" :label="item" :value="item">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="进度：" prop="schedule" class="commercial_manager">
              <el-select v-model="form.schedule" filterable placeholder="请选择">
                <el-option
                  v-for="item in formScheduleList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优先级：" prop="priority" class="commercial_manager">
              <el-select v-model="form.priority" filterable placeholder="请选择">
                <el-option
                  v-show="item.id != null"
                  v-for="item in priorityList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="button">
            <div class="add" @click="addClue">保存</div>
            <div class="cancel" @click="editInfoDialogVisible = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import uploadLogo from './components/uploadLogo.vue'
import { updateClue } from '@/api/businessCenter'
import CascaderArea from '@/components/CascaderArea'
import { getClueScheduleTime } from '@/api/businessCenter'
import keyPerson from './components/keyPerson.vue'
import linkTarget from './components/linkTarget.vue'
import enterpriseDocking from './components/enterpriseDocking.vue'
import signContract from './components/signContract.vue'
import correlationInform from './components/correlationInform.vue'

const defaultFormObj = Object.freeze({
  accomplishProject: null, // 已完成项目id（,隔开）
  city: '', // 城市
  clueCode: null, // 线索编号
  clueMessenger: '', //   	线索信息员
  createName: '', // 	创建人名字
  createTime: null, //  创建时间
  enterpriseAbbreviation: '', // 企业简称
  enterpriseName: '', // 企业全称
  enterpriseSites: '', // 企业官网
  establishTime: null, // 成立时间
  logo: '', // 企业logo
  nation: '中国', // 国家
  prepare: null, // 会前准备  1. 会前准备  2 已通知 3.已有链接
  prepareUrl: null, // 准备地址
  priority: '', // 优先级别
  province: '北京', // 省份
  schedule: '', // 进度  0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
  sourceWay: null, // 来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
  statisticsTime: null, // 线索各种数据新增时间
  updateName: null, // 修改人名字
  updateTime: null, // 修改时间
  englishName: null // 商务经理
})

export default {
  components: {
    keyPerson,
    linkTarget,
    enterpriseDocking,
    signContract,
    correlationInform,
    CascaderArea,
    uploadLogo
  },
  data() {
    return {
      row: null, // 路由跳转过来的数据
      active: 1, // 当前步骤条位置
      // tab栏
      tabList: [
        {
          value: '关键人',
          id: 0
        },
        {
          value: '链接方',
          id: 1
        },
        {
          value: '企业对接',
          id: 2
        },
        {
          value: '签约',
          id: 3
        },
        {
          value: '关联资讯',
          id: 4
        }
      ],
      // tab栏 选中数据
      tabActive: 0,
      // 进度时间
      clueScheduleTimeObj: {
        clueTime: '', //企业导入时间
        keyPersonTime: '', //关键人导入时间
        linksPartyTime: '', //链接方导入时间
        peopleTime: '', //企业对接时间
        contractTime: '' //签约时间
      },
      // 数量
      quantity: 0,
      // 优先级
      priorityList: [
        {
          value: '不限',
          id: null
        },
        {
          value: '更高',
          id: '3'
        },
        {
          value: '高',
          id: '2'
        },
        {
          value: '中',
          id: '1'
        },
        {
          value: '低',
          id: '0'
        }
      ],
      // form --> 进度
      formScheduleList: [
        {
          value: '企业导入',
          id: '0'
        },
        {
          value: '关键人导入',
          id: '1'
        },
        {
          value: '链接方导入',
          id: '2'
        },
        {
          value: '企业对接',
          id: '3'
        },
        {
          value: '企业签约',
          id: '4'
        }
      ],
      // form --> 来源方式
      sourceWayList: [
        {
          value: '智参中心',
          id: '1'
        },

        {
          value: '人工导入',
          id: '2'
        },

        {
          value: '合作方提交',
          id: '3'
        },
        {
          value: '其他',
          id: '0'
        }
      ],
      options: [
        {
          label: '商务经理',
          options: []
        },
        {
          label: '其他经理',
          options: []
        }
      ],
      editInfoDialogVisible: false, //编辑信息对话框
      form: { ...defaultFormObj }, //编辑信息表单
      rules: {
        enterpriseAbbreviation: [{ required: true, message: '请填写企业简称' }],
        sourceWay: [{ required: true, message: '请选择来源方式' }],
        clueMessenger: [{ required: true, message: '请输入线索信息员' }],
        englishName: [{ required: true, message: '请选择商务经理' }],
        schedule: [{ required: true, message: '请选择进度' }],
        priority: [{ required: true, message: '请选择优先级' }]
      }
    }
  },

  computed: {},

  watch: {
    clueScheduleTimeObj(newVal, oldVal) {
      //window.location.reload()
    }
  },

  methods: {
    // 点击tab栏
    clickTab(item) {
      this.tabActive = item.id
    },
    // 更新进度时间
    async clueScheduleTime() {
      const { data: res } = await getClueScheduleTime({
        clueCode: this.row.clueCode
      })
      if (res.resultCode == 200) {
        this.clueScheduleTimeObj = res.data
        console.log(this.clueScheduleTimeObj)
        this.active = res.data.order + 1
      }
    },
    // 数量
    quantityTotal(val) {
      this.quantity = val
      console.log(val)
      this.clueScheduleTime()
      // console.log(val)
    },
    showEditInfoDialog(row) {
      this.form = row
      console.log(this.form)
      this.editInfoDialogVisible = true
    },
    editInfoDialogClose() {},
    // 新增 --> 地点
    dialogSearchArae(val) {
      this.form.nation = val.country
      this.form.province = val.province
      this.form.city = val.city
    },
    // 图片上传路径长地址  logo
    uploadOneImgShow(value) {
      this.form.logo = value
    },
    // 选择来源方式
    clickSourceWay(item) {
      this.form.sourceWay = item.id
    },
    // 编辑线索
    addClue() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const userName = sessionStorage.getItem('userName')
          this.form.updateName = userName
          const { data: res } = await updateClue(this.form)
          if (res.resultCode == 200) {
            this.$message.success('编辑成功')
            this.editInfoDialogVisible = false
          }
        }
      })
    }
  },

  created() {
    // 从sessionStorage拿传过来的数据
    let row1 = sessionStorage.getItem('row1')
    this.row = JSON.parse(row1)
    this.clueScheduleTime()
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  overflow: scroll;
}
.head {
  background-color: #fff;
  height: 113px;
  display: flex;
  position: relative;
  margin-bottom: 16px;
  overflow: scroll;
  .left {
    width: 340px;
    display: flex;
    padding-top: 15px;
    padding-left: 10px;
    box-sizing: border-box;

    .img {
      width: 64px;
      height: 64px;
      margin-right: 9px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .text {
      display: flex;
      // width: 100%;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        -webkit-box-orient: vertical;
      }
      .position {
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-top: 13px;
        .site {
          min-width: 100px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }

        .priority {
          padding: 4px 9px 4px 10px;
          background-color: rgba(247, 104, 91, 0.2);
          margin-left: 13px;
          color: #f7685b;
          border-radius: 4px;
          border: 1px solid #f7685b;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .center {
    min-width: 600px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    /deep/.el-steps--horizontal {
      width: 100%;
    }
    /deep/.el-step__description {
      padding: 0;
    }
    /deep/.el-step__title {
      font-size: 14px;
      font-weight: 400;

      color: #06152b;
    }
    /deep/.el-step__icon-inner {
      display: none;
    }
    /deep/.el-step__icon {
      width: 16px;
      height: 16px;
    }
    /deep/.el-step__line {
      top: 8px;
    }
    // 已完成
    /deep/
      .el-steps.el-steps--horizontal
      .el-step.is-horizontal.is-center
      .el-step__head.is-finish
      .el-step__icon {
      z-index: 1;
      color: #17757a;
      border-color: #17757a;
    }
    // 正在进行process
    /deep/
      .el-steps.el-steps--horizontal
      .el-step.is-horizontal.is-center
      .el-step__head.is-process
      .el-step__icon {
      z-index: 1;
      color: #b2b2b2;
      border-color: #b2b2b2;
    }

    /deep/
      .el-steps.el-steps--horizontal
      .el-step.is-horizontal.is-center
      .el-step__head.is-finish
      .el-step__line {
      border-color: #17757a;
      background-color: #17757a;
    }
    /deep/.el-step__description {
      color: #333333;
    }

    .item {
      display: flex;
      justify-content: center;
      // align-items: center;
      .img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .right {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .information {
      .messenger {
        display: flex;
        .text {
          min-width: 100px;
        }
        .messenger_icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }
      .business_manager {
        .text {
          min-width: 80px;
        }
        .business_manager_icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        display: flex;
        margin-top: 13px;
      }
    }
    .redactInform {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      color: #1f2d3d;
      margin-left: 10px;
      background-color: #f5f5f5;
      border: 1px solid #dedede;
      cursor: pointer;
      display: flex;
      align-items: center;

      .redactInform_icon {
        font-size: 18px;
        margin: 0 5px 0 7px;
        font-weight: 700;
      }

      .text {
        // margin-left: 5px;
        font-size: 16px;
      }
    }
  }
}

.tabs {
  height: 50px;
  padding: 0;
  background-color: #f6ffff;
  display: flex;
  align-items: center;
  .tab {
    width: 120px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .text {
      font-size: 16px;
      margin-right: 7px;
    }
    .quantity {
      color: #333333;
      font-size: 14px;
      display: flex;
      align-items: center;
      // justify-content: center;
    }
  }

  .tabActiveClass {
    background-color: #fff;
    color: #17757a !important;
  }
}
.dialog {
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog__body {
    padding: 0 0 30px 0px;
  }
  /deep/.el-input__inner {
    // width: 354px;
    width: 80%;
  }
  @media (min-width: 1920px) {
    /deep/.el-input__inner {
      width: 80%;
    }
  }
  .position {
    /deep/.el-input__inner {
      width: 90px;
    }
    /deep/.middle-select {
      width: 90px !important;
    }
  }

  .commercial_manager {
    /deep/.el-input__suffix {
      right: 46px;
    }
  }

  .sourceWay {
    width: 80%;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #dcdee0;
    display: flex;
    color: #333333;
    font-size: 14px;
    overflow: hidden;

    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      cursor: pointer;
      box-sizing: border-box;
      span {
        text-align: center;
      }
    }
    .activeSourceWay {
      background-color: #17757a;
      color: #fff !important;
    }
  }

  .dialogHead {
    display: flex;
    align-items: center;
    height: 54px;
    padding-left: 16px;
    .line {
      width: 4px;
      height: 20px;
      background-color: #17757a;
      border-radius: 2px;
      margin-right: 8px;
    }
    .txt {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .button {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .add {
      color: #fff;
      width: 64px;
      height: 33px;
      background-color: #17757a;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: 4px;
      cursor: pointer;
    }
    .cancel {
      color: #17757a;
      width: 64px;
      height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid #17757a;
      margin-left: 34px;
      cursor: pointer;
    }
  }
}
</style>
